/*eslint-disable*/
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import axiosInstance from "../../../utils/axiosInstance";

const GetToken = () => {
  return localStorage.getItem("JWT");
};

export default function useBookSearch(query, incidentFlag) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [books, setBooks] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const { user } = useSelector((state) => state.user);
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  useEffect(() => {
    setBooks([]);
  }, [query]);

  useEffect(() => {
    var params = new URLSearchParams();
    params.append("type_string", query.Type);
    params.append("name_partial", query.Nombre);

    setLoading(true);
    setError(false);

    axiosInstance()
      .get("/api/v1/rules/catalogos/filter", {
        params,
        cancelToken: source.token,
      })
      .then((res) => {
        setBooks(res.data.data);
        setLoading(false);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        setError(true);
      });
    return () => source.cancel();
  }, [query, user, incidentFlag]);

  return { loading, error, books, hasMore };
}
